import { render, staticRenderFns } from "./EmailBox.vue?vue&type=template&id=165fa8fa&scoped=true&"
import script from "./EmailBox.vue?vue&type=script&lang=js&"
export * from "./EmailBox.vue?vue&type=script&lang=js&"
import style0 from "./EmailBox.vue?vue&type=style&index=0&id=165fa8fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165fa8fa",
  null
  
)

export default component.exports